<template>
  <div class="content-box">
    <!-- 로그인한 사용자정보 영역 -->
    <HconMyPageUsrInfo @data-loaded="setUserCommInfo" />
    <div class="sub-wrapper">
      <!-- 마이페이지 사이드 메뉴 -->
      <HconMyPageSideMenu />
      
      <div class="sub-contents">
        <div class="tab-area v1">
          <ul class="tab-list">
            <li v-for="(item, idx) in businessData.v1.items" 
              :key="idx"
              class="tab-item" 
              :class="{ active: businessData.v1.activeIndex === idx }">
              <button class="tab-btn" @click="handleTabClick('v1', idx)">
                <span class="tab-text">{{ item.text }}</span>
              </button>
            </li>
          </ul>
        </div>

        <div class="tab-wrap">
          <!-- 환불계좌관리 탭 -->
          <div class="tab-pannel" v-if="businessData.v1.activeIndex === 0" >
          <RefundAccount/>
          </div>
          <!-- 실지명의 계좌관리 탭
          <div class="tab-pannel" v-if="businessData.v1.activeIndex === 1" >
            <RealnameAccount/>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useRoute } from 'vue-router';
import type {UserCommonInfoDto } from '~/types/mypage/backend-dto-types';
import RefundAccount from '@/pages/pc/mypage/account/refund/index.vue';
import RealnameAccount from '@/pages/pc/mypage/account/realname/index.vue';
// 마이페이지 메뉴
import HconMyPageSideMenu from '@/components/corner/pc/HconCornerMypageSideMenuPC.vue';
// 마이페이지 화면 상단의 사용자정보 영역
import HconMyPageUsrInfo from '@/components/corner/pc/HconCornerUserInfoPC.vue';
definePageMeta({
    "require-auth" : false,
});

const route = useRoute();
const { refreshCnt, commonInfo } = useHeader();

const isActiveCategory = (category: MenuCategory) => {
  return category.items.some(item => route.path === item.link);
}

const setUserCommInfo = (data : UserCommonInfoDto) => {
  commonInfo.value = data
}

interface MenuItem {
  link: string,
  text: string
}
interface MenuCategory {
  title: string,
  items: MenuItem[]
}

const menuCategroies: MenuCategory[] = [
  { title: '주문관리', items: [{ link: '/pc/mypage/order', text: '구매관리'}, { link: '/pc/mypage/pin-publication-request', text: '핀발행 요청 관리'}] },
  { title: '결제관리', items: [{ link: '/pc/mypage/hmoney', text: 'H머니 관리'}, { link: '/pc/mypage/mileage', text: '적립금 관리'}, { link: '/pc/mypage/account', text: '계좌 관리'}] },
  { title: '쿠폰 발송 관리', items: [{ link: '/pc/mypage/sender', text: '발신번호 관리'}, { link: '/pc/mypage/coupon-top-image', text: '쿠폰 상단 이미지 관리'}, { link: '/pc/mypage/coupon-message/list', text: '쿠폰 메시지 관리'}, { link: '/pc/mypage/receive-person', text: '연락처 관리'}] },
  { title: '나의 정보 관리', items: [{ link: '/pc/mypage/information', text: '회원 정보 관리'}] },
];

const businessData = ref({
  v1: {
    items: [
      { text: '환불계좌관리'}
      // ,
      // { text: '실지명의 계좌관리'}
    ],
    activeIndex: 0
  }
});

//탭 유형 
type TabVersion = 'v1';
// 탭 클릭 핸들러
const handleTabClick = (version: TabVersion, index: number) => {
  businessData.value[version].activeIndex = index;
};

</script>

<style lang="scss" scoped>
@use "@/assets/scss/pc/mypage-hcon.scss" as *;
</style>